import React from 'react';

const SkuCalculatorResult = ({ data }) => {
  const { refProcedureSku, message } = data;

  if (!refProcedureSku) {
    return (
      <p>{ message }</p>
    )
  }

  return (
    <table>
      <thead>
        <tr>
          <th>Procedure Code</th>
          <th>Modifier</th>
          <th>Payer Code</th>
          <th>Payer Flavor</th>
          <th>Brand Code</th>
          <th>Patient Encounter</th>
          <th>SKU Code</th>
          <th>Comm Method</th>
          <th>Low High Type</th>
          <th>Low Value</th>
          <th>High Value</th>
          <th>Repeat Days</th>
          <th>Multi Conference</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>{refProcedureSku.procedureCd}</td>
          <td>{refProcedureSku.modifier}</td>
          <td>{refProcedureSku.payerCd}</td>
          <td>{refProcedureSku.payerFlavor}</td>
          <td>{refProcedureSku.brandCd}</td>
          <td>{refProcedureSku.patientEncounterCd}</td>
          <td>{refProcedureSku.skuCd}</td>
          <td>{refProcedureSku.commMethodCd}</td>
          <td>{refProcedureSku.lowHighTypeCd}</td>
          <td>{refProcedureSku.lowValue}</td>
          <td>{refProcedureSku.highValue}</td>
          <td>{refProcedureSku.repeatDays}</td>
          <td>{refProcedureSku.multiConferenceCd}</td>
        </tr>
      </tbody>
    </table>
  );
};

export default SkuCalculatorResult;
